import { Outlet } from "react-router-dom";

import HeaderVersion2 from "../headerVersion2/headerVersion2";

/**
 * Main layout component with a permanently visible sidebar and content outlet.
 * The outlet uses a flex column and `min-h-0` so nested routes (e.g. analytics
 * iframes) can fill the viewport height instead of collapsing to zero.
 */
const HomeVersion2 = () => {
  return (
    <div className="home-version-2 main-container flex h-full w-full">
      <div
        className="home-version-2__header w-[4.5rem] px-[0.62rem] py-2"
        style={{
          background:
            "linear-gradient(180deg, #090E17 0%, #090E16 3.88%, #010101 100%)",
        }}
      >
        <HeaderVersion2 />
      </div>

      <div className="home-version-2__outlet flex min-h-0 w-[calc(100%-4.5rem)] flex-1 flex-col overflow-hidden">
        <Outlet />
      </div>
    </div>
  );
};

export default HomeVersion2;
